import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { TrailingTooltip, Text as Text$1 } from '@vds/core';

const Text = (_a) => {
    var { tooltip, children, color } = _a, rest = __rest(_a, ["tooltip", "children", "color"]);
    return tooltip ? (jsx(TrailingTooltip, { surface: tooltip.surface || 'lightPrimary', tooltip: Object.assign({ iconColor: color }, tooltip), text: Object.assign(Object.assign({}, rest), { color }), children: children })) : (jsx(Text$1, Object.assign({}, rest, { color: color, children: children })));
};

export { Text as default };
